'use strict';

var _ = require('lodash');
var d3 = require('d3');
var SparseLengthOfStay = function SparseLengthOfStay() {
  /**
   * Adjust Scales for sparse data.
   * This Allow represent the sparse data modifying the thick and bars width on scales. Modify the gap width
   * to represent the date/time space between bars..
   * @param getSparseWidth : A method which return the bar / gap width on the current scale.
   * @constructor
   */
  var xSparse = function xSparse(getSparseWidth) {
    /**
     * Determinate Scale Factor.
     * Get the factor to fit the sparse data on the chart width.
     * @param data : Chart Data.
     * @param width : Chart Width.
     * @returns {number}
     */
    function scaleFactor(data, width) {
      var total = d3.sum(data, getSparseWidth);
      var totalGaps = d3.sum(_.filter(data, 'isGap'), getSparseWidth);
      var totalData = total - totalGaps;
      var preFactor = (width - totalData) / totalGaps;
      return preFactor;
    }

    /**
     * Get Scaled Width from data index.
     * @param data : Chart Data
     * @param scaleFactor : Scale Factor
     * @returns {Function}
     */
    function scaleWidth(data, scaleFactor) {
      return function (i) {
        var xScaleFactor = data[i].isGap ? scaleFactor : 1;
        return Math.floor(getSparseWidth(data[i]) * xScaleFactor);
      };
    }

    /**
     * Get Scaled Width from length of stay.
     * @param data : Chart Data
     * @param scaleFactor : Scale Factor
     * @returns {Function}
     */
    function getWidthFromLengthOfStay(data, scaleFactor) {
      return function (lengthOfStay) {
        var dataLength = _.find(data, {
          lengthOfStay: lengthOfStay
        });
        var xScaleFactor = dataLength && dataLength.isGap ? scaleFactor : 1;
        return Math.floor(getSparseWidth(dataLength) * xScaleFactor);
      };
    }

    /**
     * Distribute Thick points on Chart.
     * This modify the rangeband of the chart to distribute the sparse data according with the scaled gap width.
     * @param data : Chart Data
     * @param scaleFactor : Scale Factor.
     * @returns {Function}
     */
    function thickPoints(data, scaleFactor) {
      return function (d, i) {
        return d3.sum(data.slice(0, i), function (d) {
          var barWidth = getSparseWidth(d);
          barWidth = d.isGap ? barWidth * scaleFactor : barWidth;
          return Math.floor(barWidth);
        });
      };
    }
    return {
      scaleFactor: scaleFactor,
      scaleWidth: scaleWidth,
      thickPoints: thickPoints,
      getWidthFromLengthOfStay: getWidthFromLengthOfStay
    };
  };
  return xSparse;
};
SparseLengthOfStay.$inject = [];
module.exports = SparseLengthOfStay;